<template>
    <div>
        <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">
            <div class="content">
                <section class="section--sidebar-user">
                    <section class="section--title-sidebar">
                        <h3>Settings Skills</h3>
                    </section>
                    <section class="section--content-sidebar section--content-sidebar-full-height">
                        <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data">
                            <input type="hidden" name="_token" :value="csrf">
                            <input v-if="this.editing" type="hidden" name="_method" value="PUT">
                            <div class="form-group">
                                <label>Titolo</label>
                                <input type="text" class="form-control" name="questionBase[name]" :value="this.name">
                            </div>
                            <div class="form-group">
                                <label>{{__("forms.Question.description")}}</label>
                                <input type="text" class="form-control" name="questionBase[description]" :value="this.description">
                            </div>
                            <div class="form-group">
                                <label>{{__("forms.Question.sorting")}}</label>
                                <input type="number" class="form-control" name="questionBase[sorting]" :value="this.sorting">
                            </div>
                            <hr>
                            <div class="form-group">
                                <label>Valutazione massima</label>
                                <input type="number" class="form-control" name="questionSettings[max_evaluation]" :value="this.max_evaluation">
                            </div>
                            <label>Sezione allievo</label>
                            <div class="form-group">
                                <label> Domande al partecipante</label>
                                <br>
                                <div v-for="(group, indexG) in this.student">
                                    <label>{{__("forms.Question.title")}}</label>
                                    <input :name="'questionSettings[groups][student]['+indexG+'][title]'" v-model="group.title" type="text">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Domanda</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(question,key) in group.questions">
                                                <td><button type="button" class="btn btn--only-icon-rounded btn--danger" @click="rmStudentQuestion(indexG,key)">
                                                    <i class="fas fa-trash"></i>
                                                </button></td>
                                                <td><input :name="'questionSettings[groups][student]['+indexG+'][questions][]'" type="text" :value="question"></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <hr>
                                    <input :name="'questionSettings[groups][student]['+indexG+'][note]'" :value="group.note" type="text">
                                </div>
                            </div>

                            <div class="form-group">
                                <label> Docenti</label>
                                <br>
                                <div v-for="(group, indexG) in this.teachers">
                                    <label>{{__("forms.Question.title")}}</label>
                                    <input :name="'questionSettings[groups][teachers]['+indexG+'][title]'" v-model="group.title" type="text">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Domanda</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(question,key) in group.questions">
                                                <td><button type="button" class="btn btn--only-icon-rounded btn--danger" @click="rmTeachersQuestion(indexG,key)">
                                                    <i class="fas fa-trash"></i>
                                                </button></td>
                                                <td><input :name="'questionSettings[groups][teachers]['+indexG+'][questions][]'" type="text" :value="question"></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <hr>
                                    <input :name="'questionSettings[groups][teachers]['+indexG+'][note]'" :value="group.note" type="text">
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Tutor</label>
                                <br>
                                <div v-for="(group, indexG) in this.tutors">
                                    <label>{{__("forms.Question.title")}}</label>
                                    <input :name="'questionSettings[groups][tutors]['+indexG+'][title]'" v-model="group.title" type="text">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Domanda</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(question,key) in group.questions">
                                                <td><button type="button" class="btn btn--only-icon-rounded btn--danger" @click="rmTutorsQuestion(indexG,key)">
                                                    <i class="fas fa-trash"></i>
                                                </button></td>
                                                <td><input :name="'questionSettings[groups][tutors]['+indexG+'][questions][]'" type="text" :value="question"></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <hr>
                                    <input :name="'questionSettings[groups][tutors]['+indexG+'][note]'" :value="group.note" type="text">
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Enti</label>
                                <br>
                                <div v-for="(group, indexG) in this.training_agencies">
                                    <label>{{__("forms.Question.title")}}</label>
                                    <input :name="'questionSettings[groups][training_agencies]['+indexG+'][title]'" v-model="group.title" type="text">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Domanda</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(question,key) in group.questions">
                                                <td><button type="button" class="btn btn--only-icon-rounded btn--danger" @click="rmTrainingAgenciesQuestion(indexG,key)">
                                                    <i class="fas fa-trash"></i>
                                                </button></td>
                                                <td><input :name="'questionSettings[groups][training_agencies]['+indexG+'][questions][]'" type="text" :value="question"></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <hr>
                                    <input :name="'questionSettings[groups][training_agencies]['+indexG+'][note]'" :value="group.note" type="text">
                                </div>
                            </div>
                            <div class="form-button clear" v-if="can_write">
                                <button class="btn btn--green" type="submit">Submit</button>
                            </div>
                        </form>
                    </section>
                </section>
            </div>
        </vs-popup>
    </div>
</template>

<script>
    export default {

        props: {
            can_write:{
                type:Boolean,
                required:true,
            }
        },
        data () {
            return {
                teachers : Object,
                training_agencies : Object,
                tutors : Object,
                student : Object,
                max_evaluation : 5,
                //default
                title: "Questionario  di gradimento",
                active : false,
                action : "",
                name:"",
                description:"",
                sorting:-1,
                editing : true,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            }
        },
        methods: {
            rmStudentQuestion(indexG,key){
                //Delete element
                //Vue.delete(this.student[indexG].groups.questions[key],index);
            },
            rmTeachersQuestion(indexG,key){
                //Delete element
                //Vue.delete(this.student[indexG].groups.questions[key],index);
            },
            rmTutorsQuestion(indexG,key){
                //Delete element
                //Vue.delete(this.student[indexG].groups.questions[key],index);
            },
            rmTrainingAgenciesQuestion(indexG,key){
                //Delete element
                //Vue.delete(this.student[indexG].groups.questions[key],index);
            },

            toggle(action, item_id, editing, attributes) {
                this.active     = true;
                this.action     = action;
                this.editing    = editing;
                this.lang       = attributes.lang;
                let dataRoute   = decodeURI(attributes.dataRoute);
                if (dataRoute!==undefined) {
                    if (dataRoute.indexOf("[id]")>0) {
                        dataRoute = dataRoute.replace("[id]", item_id);

                    }
                    axios.get(dataRoute)
                        .then((response) => {

                            this.name = response.data.base.name;
                            this.description = response.data.base.description;
                            this.sorting = response.data.base.sorting;

                            this.max_evaluation = response.data.max_evaluation;
                            this.student        = response.data.groups.student;
                            console.log(this.student);
                            this.can_write = app.__vue__.questionPermission(this.can_write,response.data.base.enable);           
                        });
                }
            }

        }

    }
</script>

